import { packId } from '../../core/ids';

/** 原版包的命名空间。单独一个文件，免得 `index.ts` 和 `effects.ts` 循环引用 */
export const VANILLA_PACK_ID = packId('vanilla');
